import { Scene, SceneItem } from '@monorepo/types';
import React, { FunctionComponent, useEffect, useState } from 'react';
import { Slider } from 'antd';

import './scene-item-duration.scss';
import { useVideoContext } from '../../../../hooks/use-video';
import { formatSceneTime, formatTime } from './scene-item';

interface Props {
  scene: Scene;
  sceneItem: SceneItem;
}

const SceneItemDuration: FunctionComponent<Props> = ({ scene, sceneItem }) => {
  const [duration, setDuration] = useState([sceneItem.start, sceneItem.end]);
  const { updateSceneItem } = useVideoContext();

  const updateDuration = async (startTime: number, endTime: number) => {
    await updateSceneItem({
      sceneId: scene._id,
      videoId: scene.videoId,
      itemIndex: sceneItem.index,
      updateDto: {
        start: startTime,
        end: endTime,
      },
    });
  };

  useEffect(() => {
    setDuration([sceneItem.start, sceneItem.end]);
  }, [sceneItem.start, sceneItem.end]);

  return (
    <div className="scene-item-duration">
      <Slider
        value={duration}
        onChange={(values) => setDuration(values)}
        onChangeComplete={([startTime, endTime]) =>
          updateDuration(startTime, endTime)
        }
        tooltip={{
          formatter: (value) => {
            if (!value) {
              return '0';
            }

            return formatTime(value);
          },
        }}
        step={0.1}
        max={scene.duration}
        range
        defaultValue={[sceneItem.start, sceneItem.end]}
      />
    </div>
  );
};

export default SceneItemDuration;
